module.exports = __webpack_public_path__ + "img/智慧機械雲服務生態系統.f4630f15.png";